import React from 'react';

import { FixedSizeBanner } from '@vtblife/media-kit/dist/banners/fixed-size-banner/fixed-size-banner';

import { DeveloperPromoEventResult } from '../../../../newbuilding/developer-promo/analytics';
import { useClassifiedOfferDataLayerPush } from '../../../../offer/analytics/ClassifiedOfferGtmContext';

interface IMediaKitFixedSizeBannerProps{
    gtmClickData?: { event: string } | DeveloperPromoEventResult;
    gtmShowData?: { event: string } | DeveloperPromoEventResult;
    dataGtm?: string;
}

const MediaKitFixedSizeBanner: React.FunctionComponent<IMediaKitFixedSizeBannerProps> = ({
    gtmClickData,
    gtmShowData,
    dataGtm
}) => {
    const dataLayerPush = useClassifiedOfferDataLayerPush();

    return (
        <FixedSizeBanner
            placementId='nb-page-side'
            format='300x300'
            dataGtm={dataGtm}
            onClick={gtmClickData ? () => (dataLayerPush(gtmClickData)) : undefined}
            onShow={gtmShowData ? () => (dataLayerPush(gtmShowData)) : undefined}
            defaultProps={{
                desktopImageUrl: 'https://cdn.m2.ru/assets/file-upload-server/39b07be20aedfd9d9e1413e9226788b6.jpeg',
                format: '300x300',
                urls: [ 'https://m2.ru/ipoteka/' ]
            }}
        />
    );
};

export default React.memo(MediaKitFixedSizeBanner);
